import { combineReducers } from '@reduxjs/toolkit';
import checkoutReducer from 'stores/checkout';
import courseReducer from 'stores/course';
import coursesReducer from 'stores/courses';
import errorReducer from 'stores/errors';
import tagReducer from 'stores/tag';
import homeReducer from 'stores/home';
import modalReducer from 'stores/modals';
import ordersReducer from 'stores/orders';
import userReducer from 'stores/user';
import eScoreReducer from 'stores/eScore';
import insightsReducer from 'stores/insights';

const rootReducers = combineReducers({
  user: userReducer,
  eScore: eScoreReducer,
  modal: modalReducer,
  course: courseReducer,
  courses: coursesReducer,
  checkout: checkoutReducer,
  errors: errorReducer,
  home: homeReducer,
  orders: ordersReducer,
  tag: tagReducer,
  insights: insightsReducer
});

export type RootState = ReturnType<typeof rootReducers>;
export default rootReducers;
